import BackgroundMask from '../../atoms/mask/backgroundMask';
import Badge from '../../atoms/images/badge';
import Channel from '../../../../shared/classes/channel';
import Focus from '../../../../shared/types/enums/focus';
import List from '../list/list';
import Plan from '../../../../shared/classes/plan';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import UpgradeButton from '../../elements/buttons/upgradeButton';
import UpgradePlanModalContainer from '../../atoms/container/upgradePlanModalContainer';
import UpgradePlanModalSubtitle from '../../atoms/text/upgradePlanModalSubtitle';
import UpgradePlanModalTitle from '../../atoms/text/upgradePlanModalTitle';
import addPlanRequest from '../../../../shared/api/addPlan/request';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useEffect, useState } from 'react';
import useCloseModalKeyboard from '../../../../shared/components/utils/hooks/useCloseModalKeyboard';
import {
  clearModal,
  modalSelector,
} from '../../../../shared/store/slices/modal.slice';
import {
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';
import ModalContainer from '../../atoms/container/modalContainer';

function UpgradePlanModal() {
  const dispatch = useAppDispatch();
  const { params } = useAppSelector(modalSelector);
  const [accepted, setAccepted] = useState(params?.accepted || false);

  useCloseModalKeyboard();

  const buttons = [
    {
      title: TranslationManager.get('MODAL.UPGRADE_PLANS.BUTTONS.WANT_IT'),
      action: () => {
        addPlanRequest({
          channelCode: (params as { channel: Channel })?.channel?.code,
        });
        setAccepted(true);
      },
    },
    {
      title: TranslationManager.get('MODAL.UPGRADE_PLANS.BUTTONS.CANCEL'),
      releaseAction: () => {
        dispatch(popFocus());
        dispatch(clearModal());
      },
    },
  ];

  const acceptedButtons = [
    {
      title: 'OK',
      releaseAction: () => {
        dispatch(popFocus());
        dispatch(clearModal());
      },
    },
  ];

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
  }, []);

  return (
    <ModalContainer>
      <BackgroundMask opacity={0.9}>
        <UpgradePlanModalContainer top={accepted ? 370 : 270}>
          {!accepted ? (
            <>
              <Badge
                height={130}
                width={130}
                src={(params as { plan: Plan })?.plan?.badge}
              ></Badge>
              <UpgradePlanModalTitle>
                {TranslationManager.get('MODAL.UPGRADE_PLANS.TITLE')}
                {(params as { plan: Plan })?.plan?.name}.
              </UpgradePlanModalTitle>
              <UpgradePlanModalSubtitle>
                {TranslationManager.get('MODAL.UPGRADE_PLANS.SUBTITLE')}
              </UpgradePlanModalSubtitle>
              <List focus={Focus.MODAL_BUTTONS}>
                {buttons.map((item, index) => {
                  return (
                    <UpgradeButton
                      item={item.title}
                      action={item.action}
                      releaseAction={item.releaseAction}
                      index={index}
                      key={index}
                    ></UpgradeButton>
                  );
                })}
              </List>
            </>
          ) : (
            <>
              <UpgradePlanModalTitle>
                {TranslationManager.get('MODAL.UPGRADE_PLANS.REQUEST')}
              </UpgradePlanModalTitle>
              <List focus={Focus.MODAL_BUTTONS}>
                {acceptedButtons.map((item, index) => {
                  return (
                    <UpgradeButton
                      item={item.title}
                      releaseAction={item.releaseAction}
                      index={index}
                      key={index}
                    ></UpgradeButton>
                  );
                })}
              </List>
            </>
          )}
        </UpgradePlanModalContainer>
      </BackgroundMask>
    </ModalContainer>
  );
}
export default UpgradePlanModal;
